var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 26.0098,
    r: 25,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4493 19.9809L24.9133 13.0049C25.0141 12.803 25.1692 12.6332 25.3612 12.5146C25.5531 12.3959 25.7743 12.333 26 12.333C26.2256 12.333 26.4468 12.3959 26.6388 12.5146C26.8307 12.6332 26.9858 12.803 27.0866 13.0049L30.5506 19.9809L38.2946 21.1063C38.518 21.1372 38.7282 21.2304 38.9011 21.3751C39.0741 21.5198 39.2029 21.7102 39.2728 21.9246C39.3428 22.139 39.351 22.3687 39.2966 22.5875C39.2423 22.8064 39.1274 23.0055 38.9653 23.1623L33.3626 28.5889L34.6853 36.2556C34.8546 37.2396 33.8146 37.9889 32.9253 37.5249L26 33.9036L19.0733 37.5249C18.1853 37.9903 17.1453 37.2396 17.3146 36.2543L18.6373 28.5876L13.0346 23.1609C12.8733 23.0041 12.7592 22.8051 12.7053 22.5867C12.6513 22.3682 12.6598 22.139 12.7297 21.9251C12.7995 21.7112 12.928 21.5212 13.1005 21.3767C13.2729 21.2322 13.4825 21.139 13.7053 21.1076L21.4493 19.9809Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStarIcon);
export default __webpack_public_path__ + "static/media/white_star_icon.f7367d5412e741c929761322ba7243a9.svg";
export { ForwardRef as ReactComponent };